/** Textos de chrome (header / volver) según acceso. lenguajeId 2 = Pedagogical Exercises (EN). */
export function isEnglishUi(lenguajeId) {
  return Number(lenguajeId) === 2;
}

export function uiLabels(lenguajeId) {
  if (isEnglishUi(lenguajeId)) {
    return {
      home: 'HOME',
      back: 'BACK',
      backTopLine1: 'BACK',
      backTopLine2: 'TO TOP',
      pagesOfInterest: 'PAGES OF\nINTEREST',
      installApp: 'INSTALL\nAPP',
    };
  }
  return {
    home: 'INICIO',
    back: 'VOLVER',
    backTopLine1: 'VOLVER',
    backTopLine2: 'ARRIBA',
    pagesOfInterest: 'PÁGINAS DE\nINTERÉS',
    installApp: 'INSTALAR\nAPP',
  };
}
